import moment from 'moment';

export const CHANGE_MOBILE_PAGES_EVENT_ID = 'clinic-profile-change-mobile-page';
export const MOBILE_PAGES = {
  INDEX: 'index',
  CATEGORIES: 'categories',
  DOCTOR_PAGE: 'doctor',
  MESSAGE_PAGE: 'message',
  LOCATIONS_PAGE: 'locations',
  MANAGERS_PAGE: 'managers',
  LOCATION_PAGE: 'location'
};

const RESIZE = 0.9;

export const MIN_DESKTOP_WIDTH = 1520 * RESIZE;
export const MIN_DESKTOP_HEIGHT = 950 * RESIZE;
export const MAX_WIDTH = 1600 * RESIZE;

export const remCss = (v) => {
  return v * RESIZE;
};

export const remFontCss = (v) => {
  return v * RESIZE;
};

export const workingTimes = (schedule) => {
  const list = [];
  const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
  days.forEach((d, i) => {
    const data = (schedule && schedule[d.toLowerCase()]) || {};
    const times = (data?.times || []).filter((t) => t.startTime && t.endTime);
    let time = 'Closed';
    if (data?.isOpen && times.length > 0) {
      time = times
        .map(
          (t) => moment(t.startTime).format('HH:mm A') + ' - ' + moment(t.endTime).format('HH:mm A')
        )
        .join(', ');
    }
    let index = list.findIndex(
      (item) => item.time === time && (item.to + 1 === i || item.from + 1 === i)
    );
    if (index > -1) {
      list[index].to = i;
    } else {
      list.push({
        time,
        from: i
      });
    }
  });

  return list.map((item) => ({
    day: `${days[item.from].slice(0, 3)}${item.to ? ' - ' + days[item.to].slice(0, 3) : ''}`,
    time: item.time
  }));
};
